module.exports = __webpack_public_path__ + "static/media/questionnaire-step2.f315e00b.png";